export default "__VITE_ASSET__Ckh2TR6I__"